// extracted by mini-css-extract-plugin
export default {"container":"Home_container__CrYAc","challengeBox":"Home_challengeBox__D8c0m"};